import React, { FC } from 'react';
import WidgetArticlesProps from 'modules/shared/widgets/components/widget-articles/widget-articles.props';
import WidgetArticle from 'modules/shared/widgets/components/widget-articles/components/widget-article';
import { useNativeArticles } from '../hooks/use-native-articles';
import AdSlotNativeArticle from 'components/ads/ad-slot-native-article';
import { SLOT_NATIVE_ARTICLE } from 'components/ads/ad-slot/ad-defs';

import './widget-articles-desktop.scss';

const WidgetArticlesDesktop: FC<WidgetArticlesProps> = ({ data }) => {
    const { mergedItems, nativeSlots } = useNativeArticles(data);

    return (
        <div className="w-articles-d">
            <ul className="w-articles-d__list">
                {mergedItems.map((item, idx) => (
                    <li key={`${item.url}-${idx}`} className="w-articles-d__item">
                        <WidgetArticle
                            {...item}
                            title={item.title.trim() || `Obrazek ${idx}`}
                        />
                    </li>
                ))}
            </ul>
            {nativeSlots.map(nativeItem => (
                nativeItem.index >= 0 && (
                    <AdSlotNativeArticle
                        key={nativeItem.id}
                        id={nativeItem.id}
                        pos={nativeItem.index + 1}
                        name={SLOT_NATIVE_ARTICLE}
                    />
                )
            ))}
        </div>
    );
};

export default WidgetArticlesDesktop;
